import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<TitledLabel class={{this.styles.title-label}}>\n  <:title>Nombre</:title>\n  {{!-- @glint-expect-error --}}\n  <:body><span class=\"ui big text\">{{@currentSelection.length}}</span></:body>\n</TitledLabel>", {
  moduleName: "core/components/das28/titled-labels/articulations-counted/index.hbs"
});